import { render, staticRenderFns } from "./VolumeDetails.vue?vue&type=template&id=0f337407"
import script from "./VolumeDetails.vue?vue&type=script&lang=js"
export * from "./VolumeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports